<template>
  <div>
    <div class="ncgr-mar-b-16">
      <table class="ncgr-table -size-s -density-dense">
        <tbody>
          <tr>
            <th>
              サイズ
            </th>
            <th v-for="(header, index) in headers" :key="index" class="ncgr-align-right">
              {{ header }}
            </th>
          </tr>
          <tr v-for="(cols, size) in sizes" :key="size">
            <td class="ncgr-typography-bold">
              {{ size }}
            </td>
            <td v-for="(col, index) in cols" :key="index" class="ncgr-align-right">
              {{ col }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="ncgr-mar-b-16">
      <h2 class="ncgr-heading -size-s">
        型番
      </h2>
      <ul class="ncgr-ul -density-dense">
        <li>
          {{ $t(`item-name.${itemName}.long`) }}
        </li>
        <li>
          在庫切れの際に使用: {{ t(`substitute.${itemName}`) }}
        </li>
      </ul>
    </div>
    <div>
      <h2 class="ncgr-heading -size-s">
        素材・材質
      </h2>
      <ul class="ncgr-ul -density-dense">
        <li>
          {{ t(`fabric.${itemName}`) }}
        </li>
      </ul>
    </div>
  </div>
</template>

<i18n lang="yaml">
ja:
  fabric:
    t-shirt-united-athle-5001: '綿100%（オートミール：綿99%・ポリエステル1%）'
    long-sleeve-t-shirt-united-athle-5011: '綿100%（アッシュ：綿98%・ポリエステル2%）'
    sweat-united-athle-5044: '綿100％, 裏パイル'
  substitute:
    t-shirt-united-athle-5001: 'Printstar 00085-CVT 5.6オンス'
    long-sleeve-t-shirt-united-athle-5011: 'GILDAN 2400 ウルトラコットン長袖Tシャツ 6オンス'
    sweat-united-athle-5044: 'Printstar 00183-NSC 9.7オンス スタンダードトレーナー'
</i18n>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { ItemSpec } from '@/lib/item-spec'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  props: {
    itemName: {
      type: String,
      required: true
    }
  },
  setup (props) {
    const { t } = useI18n()

    const headers = computed(() => ItemSpec.sizeTable(props.itemName).headers)
    const sizes = computed(() => ItemSpec.sizeTable(props.itemName).body)

    return { t, headers, sizes }
  }
})
</script>
